<!-- IndexCateListNew 小图标 样式 -->

<template>
  <div class="mt1 nav-top-class-new"
    style="border-radius: 8px; padding: 15px 0; margin:15px;">

    <van-grid :border="false" :column-num="4" style="border-radius: 16px;font-size: 12px;">
      <van-grid-item v-for="(cate, index) of allowCateInfo" :key="index"
        :text="cate.extNameV3 || '栏目 ' + JSON.stringify(cate)" @click="toModuleIndex(cate.topCateId, cate.targetUrl)">
        <template #icon>
          <van-icon :name="cate.headImage || 'images/index-new/class/shangcheng_1.svg'" size="48" />
        </template>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
export default {
  props: ['allowCateInfo', 'mall_modules'],

  methods: {
    getModuleIndexUrl(cateId) {
      switch (cateId) {
        case 3:
          return '/birthday';
        case 1:
          return '/index'
        case 7:
          return '/travel-index';
        case 8:
          return '/health-index';
        default:
          return '/common-index?cateId=' + cateId;
      }
    },

    toModuleIndex(id, targetUrl) {
      budo_log.debug("#39 toModuleIndex", id, targetUrl)

      if (targetUrl) {
        location.href = targetUrl
        return
      }

      if (id === 2) {
        location.href = '/movie/index'
        return
      }

      if (id === 999) {
        this.$router.push('/topic-list')
        return
      }

      let mid = id;

      // 生日版块特殊处理
      if (id === 3) {
        mid = 4;
      }

      const module = this.mall_modules.find((mall) => mall.topCateId === mid);
      if (module) {
        this.$store.commit("SET_MALL_MODULE", module);
        sessionStorage.setItem('rc.module-info', JSON.stringify(module));

        this.$store.commit("CLEAR_CART");
        this.$EventBus.$emit("routeInfo", JSON.stringify(module || {}));

        budo_log.debug('#71 module_name', module)
      }

      this.$router.push(this.getModuleIndexUrl(id));
    }
  }
}
</script>

<style>
.nav-top-class-new {
  box-shadow: 1px 1px 5px #e1e1e1;
}
</style>
